export interface GasProduct {
  id: string;
  name: string;
  subtitle: string;
  tagline: string;
  description: string;
  images: string[];
  features: string[];
  highlights: { title: string; value: string; icon: string }[];
  pdfUrl?: string;
  mainCharacteristics: Record<string, string>;
  physicalCharacteristics: Record<string, string>;
  accessoryImages?: { accName: string; accImage: string }[];
}

export const gasProducts: GasProduct[] = [
  {
    id: "gas-mini",
    name: "Gas-Mini",
    subtitle: "Portable Gas Detector",
    tagline: "Zone 1/21 / IP67 Rated",
    description: `Gas-mini is an industrial-grade portable single gas detector. Its compact and rugged design is meant to withstand harsh environments while providing ease of use in a critical hazardous atmosphere. It comes in three gas variants: Oxygen (O2), Carbon Monoxide (CO), and Hydrogen Sulphide (H2S).

Gas-mini’s bright LCD display with loud alarms and vibrations is helpful in a noisy environment. The rugged exterior provides accurate reading even when exposed to temperatures ranging from -20°C to +60°C. It is designed and tested to meet global IS standards, ensuring safe operations in hazardous environments.`,
    images: [
      "/images/products/gas-detector/gas-mini-front.png",
      "/images/products/gas-detector/gas-mini-back.png",
    ],
    features: [
      "INTRINSICALLY SAFE: Explosion Proof / ATEX Zone 1/21",
      "ALARMS: Light, Sound, Vibration (>90dB)",
      "ULTRA-RUGGED: IP67 Protection",
      "SENSOR RANGE: O2 (0-30%), H2S (0-500ppm), CO (0-1000ppm)",
      "WEIGHT: Ultra-light 150 grams",
      "BATTERY: Long-life 9V Lithium",
    ],
    highlights: [
      { title: "Protection", value: "IP67", icon: "ion:shield-checkmark" },
      { title: "Response", value: "<20s", icon: "ion:timer" },
      { title: "Alarm", value: ">90dB", icon: "ion:volume-high" },
      { title: "Weight", value: "150g", icon: "ion:scale" },
    ],
    pdfUrl: "/documents/gas-detector/gas-mini.pdf",
    mainCharacteristics: {
      "Sampling Method": "Natural Diffusion",
      Display: "LCD",
      "Sensor Type": "Electrochemical",
      "IP Protection": "IP 67",
      Battery: "9V Lithium",
      Warranty: "2 years (with 3 alarm mins/day)",
      "Sensor Range": "O2, H2S, CO",
      Resolution: "1 ppm",
      "Sensor Life": "2 Years",
    },
    physicalCharacteristics: {
      Dimensions: "110 × 45 × 31 mm",
      Weight: "150 gms",
      "Alarm Items": "Low / High / STEL / TWA / Low Battery",
      "Alarm Methods": "Red LED, Buzzer (>90dB), Vibration",
      "Response Time": "≤ 20 seconds",
      "Op. Temperature": "-20°C to +60°C",
    },
    accessoryImages: [
      {
        accName: "Calibration Caps",
        accImage: "/images/products/gas-detector/acc-calibrator.png",
      },
      {
        accName: "Clips",
        accImage: "/images/products/gas-detector/acc-clip.png",
      },
    ],
  },
  {
    id: "gas-max",
    name: "Gas-Max",
    subtitle: "Portable Multi Gas Detector",
    tagline: "Zone 0/20 / IP67 Rated",
    description: `A rugged portable multi gas detector with a compact and affordable design meant to withstand harsh environments. Developed with a User-Centered Design Process to make the device interface and handling highly intuitive. 

The bright color LCD display with loud alarms and vibrations is helpful in a noisy environment. The rugged anti-static exterior provides accurate reading even when exposed to temperatures ranging from -20°C to +60°C and humidity ~95% RH. The small and lightweight package can host upto 4 gas sensors. The standard 4 gas combination includes CO, H2S, Methane, and O2.`,
    images: [
      "/images/products/gas-detector/gas-max-front.png",
      "/images/products/gas-detector/gas-max-back.png",
    ],
    features: [
      "INTRINSICALLY SAFE: Explosion Proof / ATEX Zone 0/20",
      "ALARMS: Light, Sound, Vibration",
      "ULTRA-RUGGED: IP67",
      "SENSORS: Hosts up to 4 sensors (CO, H2S, Methane, O2, etc.)",
      "HUMIDITY: 10%-95% RH (no condensation)",
      "BATTERY: 1300 mAh (Rechargable)",
    ],
    highlights: [
      { title: "Zone", value: "Zone 0/20", icon: "ion:alert-circled" },
      { title: "Sensors", value: "Multi (4)", icon: "ion:grid-outline" },
      { title: "Protection", value: "IP67", icon: "ion:shield-checkmark" },
      { title: "Battery", value: "1300 mAh", icon: "ion:battery-half" },
    ],
    pdfUrl: "/documents/gas-detector/gas-max.pdf",
    mainCharacteristics: {
      "Sampling Method": "Diffusion",
      Display: "TFT Color LCD Screen",
      "Sensor Type": "Electrochemical, Catalytic",
      "IP Protection": "IP 67",
      Warranty: "2 Years",
      Battery: "1300 mAh",
      "Response Time": "T90 < 30S",
      "Humidity Range": "10%-95% RH",
      "Sensor Range":
        "Methane (0-100%LEL), O2 (0-30%VOL), H2S (0-100 ppm), CO (0-500 ppm), etc.",
    },
    physicalCharacteristics: {
      Size: "123.88 x 65 x 50.7 mm",
      Weight: "182 gms",
      "Alarm Methods": "Sound, Light, and Vibration",
      "Sound Intensity": "65dB @ 25cms",
      Charger: "USB powered DC 5V",
    },
    accessoryImages: [], // No accessories listed in source text
  },
];
